<template>
  <v-hover v-slot:default="{ hover }" open-delay="100">
    <v-btn
      :elevation="hover ? 8 : 0"
      variant="outlined"
      :color="color"
      :block="block"
      :size="large ? 'large' : 'default'"
      :rounded="rounded"
      :class="[textColor, textHover, bgHover, borderColor]"
      class="border"
    >
      {{ text }}
    </v-btn>
  </v-hover>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'OutlineButton',
  props: {
    text: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    block: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },

    textColor: {
      type: String,
      default: 'white--text',
    },
    textHover: {
      type: String,
      default: 'hover:white--text',
    },
    bgHover: {
      type: String,
      default: 'primary',
    },
    borderColor: {
      type: String,
      default: '',
    },
  },
})
</script>
